import { graphql } from "gatsby";
import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

import { Careers } from "ducks/Careers/index";

export default function CareersPage({
  data: { careers: { nodes: careers = [] } = {} } = {},
}) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Careers - Savant Power"}</title>
      </Helmet>
      <Careers careers={careers} />
    </Fragment>
  );
}

CareersPage.propTypes = {
  data: PropTypes.shape({ careers: PropTypes.object }),
};

export const query = graphql`
  query RpeCareersQuery {
    careers: allMarkdownRemark {
      nodes {
        id
        frontmatter {
          title
          uid
          uri
          url
        }
      }
    }
  }
`;
